import { number, string } from 'prop-types'

export default {
  index: number,
  text: string,
}
